/*
 * @Author: 刘小博
 * @Date: 2023-02-17 15:41:53
 * @LastEditTime: 2023-02-17 15:47:41
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\cost-control\cost-settle-accounts\modules\flowSettleAccountsRouter.js
 * 流向结算
 */
import store from '@/store'
import { getAuthClientList } from '@/api/common'

const flowSettleAccountsRouter = [
  // 费控系统 流向结算 流向管理
  {
    path: '/costControlSystem/flow-settlement/flow-management',
    name: 'costControlSystemFlowManagement',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/flowSettlement/flowManagement/index.vue'
      ),
    meta: {
      SecondaryMenu: '流向结算', //二级菜单
      title: '流向管理',
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
  // 费控系统 流向结算 流向数据审核
  {
    path: '/costControlSystem/flow-settlement/flow-management/to-examine',
    name: 'costControlSystemFlowManagementToExamine',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/flowSettlement/flowManagement/indexToExamine.vue'
      ),
    meta: {
      SecondaryMenu: '流向结算', //二级菜单
      title: '流向数据审核',
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
  // 费控系统 流向结算 流向结算清单
  {
    path: '/costControlSystem/flow-settlement/detailed',
    name: 'costControlSystemFlowManagementDetailed',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/flowSettlement/detailed/index.vue'
      ),
    meta: {
      SecondaryMenu: '流向结算', //二级菜单
      title: '流向结算清单',
    },
  },
  // 费控系统 流向结算 流向结算清单 添加编辑结算清单
  {
    path: '/costControlSystem/flow-settlement/flow-management/add-edit/:cost_settlement_id',
    name: 'costControlSystemFlowManagementDetailedAddEdit',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/flowSettlement/detailed/addEdit.vue'
      ),
    meta: {
      SecondaryMenu: '流向结算', //二级菜单
      title: '添加结算清单',
      breadcrumb: [
        {
          title: '流向结算清单',
          name: 'costControlSystemFlowManagementDetailed',
        },
      ],
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
  // 费控系统 流向结算 流向结算清单 详情
  {
    path: '/costControlSystem/flow-settlement/flow-management/detail/:cost_settlement_id',
    name: 'costControlSystemFlowManagementDetailedDetail',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/flowSettlement/detailed/detail.vue'
      ),
    meta: {
      SecondaryMenu: '流向结算', //二级菜单
      title: '流向结算清单详情',
      breadcrumb: [
        {
          title: '流向结算清单',
          name: 'costControlSystemFlowManagementDetailed',
        },
      ],
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
]
export default flowSettleAccountsRouter
